import { connect } from "react-redux";
import { AddVehicleByMakeModel as Component } from "./AddVehicleByMakeModel.component";
import { RootState } from "../../../reducers";
import {
  requestMakeModel,
  resetMakeModel,
  updateAccidentQuestions,
  updateServiceTypeOptions,
  updateVehicle,
  updateVehicleInfo,
} from "../../../action";
import {
  getAccidentQuestionResponse,
  getCommonBenefits,
  getMakeModel,
  getPartnerDetails,
  getServiceInfo,
  getServiceRequestPayload,
} from "../../../selector";
import { saveRescueDetailsRetrieveResultsRequest } from "../../../action/saveRescueDetails-action";
import { getOmniStreamlinedFlag } from "../../../features/FeatureFlags/selectors";


const mapStateToProps = (state: RootState) => ({
  commonBenefits: getCommonBenefits(state),
  partnerDetails: getPartnerDetails(state),
  makeModel: getMakeModel(state),
  serviceInfo: getServiceInfo(state),
  serviceRequestPayload: getServiceRequestPayload(state),
  accidentQuestionFromRedux : getAccidentQuestionResponse(state),
  omniStreamlinedFlag: getOmniStreamlinedFlag(state)
});

export const AddVehicleByMakeModel = connect(mapStateToProps, {
  requestMakeModel,
  resetMakeModel,
  saveRescueDetailsRetrieveResultsRequest,
  updateAccidentQuestions,
  updateServiceTypeOptions,
  updateVehicle,
  updateVehicleInfo
})(Component);
